import { DefaultApi } from './api'
import { Invoice, InvoiceRecords } from './interfaces'

export const getInvoiceData = (type = 'subscription'): Promise<Invoice> => {
  return DefaultApi.request(`/company/invoices?kind_service=${type}`, {
    method: 'GET',
  })
}

export const getInvoiceRecords = (page = 1, perPage = 10, type = 'subscription'): Promise<InvoiceRecords> =>
  DefaultApi.request(`/company/invoices/index?page=${page}&per_page=${perPage}&kind_service=${type}`, {
    method: 'GET',
  })
